

export function Bubble(props: React.SVGProps<SVGSVGElement>) {
    return (
        <svg
            viewBox="0 0 24 24"
            {...props}
            stroke="currentColor"
            strokeWidth="currentStroke"
            fill="none" xmlns="http://www.w3.org/2000/svg">
            <circle cx="17" cy="8" r="4"/>
            <circle cx="12" cy="17" r="3"/>
            <circle cx="6.5" cy="9.5" r="2.5"/>
        </svg>
    )
}